import React from 'react';

const ProfileEmployee = () => {
    return (
        <div style={{ fontFamily: 'Arial, sans-serif' }}>
            <h3 style={{ fontSize: '20px', fontWeight: '400' }}>Step 1: Select Profile in Sidebar</h3>
            <p>Click on the profile icon in the sidebar to navigate to the profile page.</p>
            <img src="https://res.cloudinary.com/danfpnuui/image/upload/v1737208928/Pro-6_cvobcd.png" alt="Profile Selection" style={{ width: "60%", height: "auto", marginBottom: "20px" }} />
            
            <h3 style={{ fontSize: '20px', fontWeight: '400' }}>Step 2: Edit Profile Details</h3>
            <p>On the profile page, click on the <strong>Edit</strong> button to update user details like First Name, Last Name, Phone Number, Experience, and Job Role. Don't forget to save your changes.</p>
            <img src="https://res.cloudinary.com/danfpnuui/image/upload/v1737209012/Pro-1_iww6qf.png" alt="Edit Profile" style={{ width: "60%", height: "auto", marginBottom: "20px" }} />
            
            <h3 style={{ fontSize: '20px', fontWeight: '400' }}>Step 3: Add Educational Details</h3>
            <p>Click on the <strong>Add</strong> button in the Educational Details section to enter your education information.</p>
            <img src="https://res.cloudinary.com/danfpnuui/image/upload/v1737209091/Pro-2_qitvps.png" alt="Educational Details" style={{ width: "60%", height: "auto", marginBottom: "20px" }} />
            
            <h3 style={{ fontSize: '20px', fontWeight: '400' }}>Step 4: Add Work Experience</h3>
            <p>Select Work Experience and click the <strong>Add</strong> button to enter job details including Job Title, Company Name, Start Date, End Date, and Description.</p>
            <img src="https://res.cloudinary.com/danfpnuui/image/upload/v1737209534/Pro-3_zd2o87.png" alt="Work Experience" style={{ width: "60%", height: "auto", marginBottom: "20px" }} />
            
            <h3 style={{ fontSize: '20px', fontWeight: '400' }}>Step 5: Add Skill Set</h3>
            <p>Choose Skill Set and click the <strong>Add</strong> button to include skills like Skill Name, Rating / 100, and Version. Remember to save your entries.</p>
            <img src="https://res.cloudinary.com/danfpnuui/image/upload/v1737209533/Pro-4_ghjzn2.png" alt="Skill Set" style={{ width: "60%", height: "auto", marginBottom: "20px" }} />
            
            <h3 style={{ fontSize: '20px', fontWeight: '400' }}>Frequently Asked Questions</h3>
            <h4 style={{ fontSize: '20px', fontWeight: '400' }}>Can I change my profile details?</h4>
            <p>Yes, you can edit your profile details by clicking the <strong>Edit</strong> button on your profile page.</p>
            
            <h4 style={{ fontSize: '20px', fontWeight: '400' }}>How do I add my work experience?</h4>
            <p>Navigate to the Work Experience section and click the <strong>Add</strong> button. Enter the required job details and save.</p>
            
            <h3 style={{ fontSize: '20px', fontWeight: '400' }}>Things to Remember</h3>
            <ul>
                <li>Ensure all updated information is accurate and up-to-date.</li>
                <li>Click <strong>Save</strong> after editing each section to ensure your changes are stored.</li>
            </ul>
        </div>
    );
};

export default ProfileEmployee;
